<template>
  <div>
    <h3 style="margin-left:100px;">基本信息填写：</h3>
    <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
      <div class="m_flex_column" style="width:100px;">研究方案名称：</div>
      <a-input v-model="project.name" placeholder="请输入" allowClear style="width:500px" />
    </div>
    <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
      <div class="m_flex_column" style="width:100px;">方案编号：</div>
      <a-input v-model="project.plan_number" placeholder="请输入" allowClear style="width:500px" />
    </div>
    <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
      <div class="m_flex_column" style="width:100px;">申办方机构：</div>
      <a-input v-model="project.sponsor" placeholder="请输入" allowClear style="width:500px" />
    </div>
    <div class="m_flex_row" style="margin-left:120px;margin-top:30px;">
      <div class="m_flex_column" style="width:100px;">项目介绍:</div>
      <a-textarea
        :autosize="{ minRows: 6, maxRows: 20 }"
        v-model="project.introduce"
        placeholder="请输入"
        allowClear
        style="width:500px"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "ProjectAddShow",
  props: {
    project: Object
  },
  data() {
    return {
    };
  },
  
};
</script>

<style>
</style>